export const DELIVERY_TERMS_MODE_AVG = "avg";
export const DELIVERY_TERMS_MODE_RANGE = "range";

type DeliveryTermsMode = string | null | undefined;

type StandardDeliveryTerms = {
  deliveryTermStandardMin?: number | null;
  deliveryTermStandardAvg?: number | null;
  deliveryTermStandardMax?: number | null;
};

export const getStandardDeliveryTermWindow = (
  price: StandardDeliveryTerms,
  mode: DeliveryTermsMode,
) => {
  if (mode === DELIVERY_TERMS_MODE_AVG) {
    return {
      from: price.deliveryTermStandardAvg,
      to: price.deliveryTermStandardAvg,
    };
  }

  return {
    from: price.deliveryTermStandardMin,
    to: price.deliveryTermStandardMax,
  };
};

export const getGroupedStandardDeliveryTermWindow = (
  prices: StandardDeliveryTerms[],
  mode: DeliveryTermsMode,
) => {
  if (mode === DELIVERY_TERMS_MODE_AVG) {
    const deliveryTerm = prices.reduce<number | null>((maxTerm, price) => {
      if (price.deliveryTermStandardAvg == null) {
        return maxTerm;
      }

      return maxTerm === null
        ? price.deliveryTermStandardAvg
        : Math.max(maxTerm, price.deliveryTermStandardAvg);
    }, null);

    return {
      from: deliveryTerm,
      to: deliveryTerm,
    };
  }

  let from: number | null = null;
  let to: number | null = null;

  for (const price of prices) {
    if (price.deliveryTermStandardMin != null) {
      from = from === null
        ? price.deliveryTermStandardMin
        : Math.min(from, price.deliveryTermStandardMin);
    }

    if (price.deliveryTermStandardMax != null) {
      to = to === null
        ? price.deliveryTermStandardMax
        : Math.max(to, price.deliveryTermStandardMax);
    }
  }

  return { from, to };
};
